// src/components/LanguageSelector.jsx
import React, { useState } from 'react';
import { LANGUAGES } from '../lib/i18n';
import { ChevronDown } from 'lucide-react';

export default function LanguageSelector({ lang, setLang, dark = false }) {
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  return (
    <div style={{ position: 'relative' }}>
      <button onClick={() => setOpen(o => !o)} style={{
        display: 'flex', alignItems: 'center', gap: 6,
        background: dark ? 'rgba(255,255,255,0.05)' : 'transparent',
        border: `1px solid ${dark ? 'rgba(255,255,255,0.1)' : '#1e1e2e'}`,
        borderRadius: 7, padding: '6px 10px', cursor: 'pointer',
        color: dark ? '#f0f0f5' : '#8888a8', fontSize: 12,
        fontFamily: "'IBM Plex Sans', sans-serif",
        transition: 'all 0.2s', outline: 'none',
      }}
        onMouseEnter={e => e.currentTarget.style.borderColor = '#00e5a0'}
        onMouseLeave={e => e.currentTarget.style.borderColor = dark ? 'rgba(255,255,255,0.1)' : '#1e1e2e'}>
        <span style={{ fontSize: 15, lineHeight: 1, display: 'inline-flex', alignItems: 'center' }} aria-hidden>{current.flag}</span>
        <span style={{ display: window.innerWidth > 640 ? 'inline' : 'none' }}>{current.label}</span>
        <ChevronDown size={11} style={{ opacity: 0.6, transform: open ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.2s' }} />
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', right: 0,
          background: '#16161f', border: '1px solid #2a2a3e',
          borderRadius: 10, minWidth: 160, zIndex: 200,
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
          animation: 'fadeIn 0.15s ease', overflow: 'hidden',
          maxHeight: 320, overflowY: 'auto',
        }}>
          {LANGUAGES.map(l => (
            <button key={l.code} onClick={() => { setLang(l.code); setOpen(false); }} style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: 10,
              padding: '9px 14px', background: lang === l.code ? 'rgba(0,229,160,0.08)' : 'none',
              border: 'none', cursor: 'pointer', textAlign: 'left',
              borderBottom: '1px solid #1a1a26',
              transition: 'background 0.15s', outline: 'none',
            }}
              onMouseEnter={e => e.currentTarget.style.background = lang === l.code ? 'rgba(0,229,160,0.1)' : '#1c1c28'}
              onMouseLeave={e => e.currentTarget.style.background = lang === l.code ? 'rgba(0,229,160,0.08)' : 'none'}>
              <span style={{ fontSize: 17, lineHeight: 1, display: 'inline-flex', alignItems: 'center', width: 20 }} aria-hidden>{l.flag}</span>
              <span style={{ fontSize: 13, color: lang === l.code ? '#00e5a0' : '#f0f0f5', fontFamily: "'IBM Plex Sans', sans-serif" }}>
                {l.label}
              </span>
              {lang === l.code && <span style={{ marginLeft: 'auto', color: '#00e5a0', fontSize: 12 }}>✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
